import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-baseline-category-24px",
  "use": "icon-baseline-category-24px-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-baseline-category-24px\">\n    <path d=\"M12 2l-5.5 9h11z\" />\n    <circle cx=\"17.5\" cy=\"17.5\" r=\"4.5\" />\n    <path d=\"M3 13.5h8v8H3z\" />\n    <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol